import { useQuery } from '@apollo/react-hooks';

import { getLearningResultLessons } from 'GraphQL/queries/attendanceFilter.query';

import {
  isLearningResultLessonsSkipped,
  toLearningResultLessonsVariables,
} from './AttendanceFilterData';

/**
 * Name of the selected lesson (`lesson` is its lesson ID) in the lesson filter of learning result
 * lessons, e.g. for quiz feed tables, which have only lesson name.
 * It uses the same query and variables as the lesson filter, so it is read from Apollo cache.
 *
 * @param {object} value filter value, e.g. from query string
 * @param {string} schoolCode
 * @returns {{ isLessonSelected: boolean, lessonName?: string }} `lessonName` is undefined
 * while loading or when the lesson is not in the lesson filter
 */
const useLessonName = (value, schoolCode) => {
  const { lesson } = value;
  const isLessonSelected = !!lesson && lesson !== `all-lesson-selected`;
  const { data } = useQuery(getLearningResultLessons, {
    variables: toLearningResultLessonsVariables(value, schoolCode),
    skip: !isLessonSelected || isLearningResultLessonsSkipped(value, schoolCode),
  });
  const lessonName = data?.foLearningResultLessons?.find(({ lessonId }) => lessonId === lesson)
    ?.lessonName;
  return { isLessonSelected, lessonName };
};

export default useLessonName;
